export const Colors ={
    Primary: '#5a32a8',
    Secondary: '#FFFFFF',
    Page: '#edebeb'
}
